import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CombinedContext } from "../../context/combinedContext";
import "./footer.css";
import translations from "../../translations/translations";
import googlePlayEN from "../../images/downloadApp/googlePlayStoreEN.png";
import googlePlayES from "../../images/downloadApp/googlePlayStoreES.png";
import appStoreEN from "../../images/downloadApp/appStoreEN.png";
import appStoreES from "../../images/downloadApp/appStoreES.png";
import logo from "../../images/logoTransparent.png";
import { FaInstagram, FaFacebookF, FaTwitter } from "react-icons/fa";

const Footer = () => {
	const { language, setLanguage, userData } = useContext(CombinedContext);

	const isEN = language === "en";
	const role = userData?.user?.role;

	return (
		<footer className="sf-footer">
			{/* ======= TOP LINKS + DOWNLOAD BUTTONS ======= */}
			<div className="sf-footer-top">
				<div className="sf-footer-links">
					<Link to="/about" onClick={() => window.scrollTo({ top: 0 })}>{translations[language].footer.links.about}</Link>
					<Link to="/privacy" onClick={() => window.scrollTo({ top: 0 })}>{translations[language].footer.links.privacy}</Link>
					<Link to="/terms" onClick={() => window.scrollTo({ top: 0 })}>{translations[language].footer.links.terms}</Link>
					<Link to="/contact" onClick={() => window.scrollTo({ top: 0 })}>{translations[language].footer.links.contact}</Link>
					<Link to="/refund" onClick={() => window.scrollTo({ top: 0 })}>{translations[language].footer.links.refundPolicy}</Link>
					{(!role || role === "customer") && <Link to="/businesslanding" onClick={() => window.scrollTo({ top: 0 })}>{translations[language].navbar.auth.listShop}</Link>}
				</div>

				<div className="sf-footer-apps">
					<a href="#" aria-label={translations[language].footer.apps.appStoreAria}>
						<img src={isEN ? appStoreEN : appStoreES} alt="App Store" />
					</a>
					<a href="#" aria-label={translations[language].footer.apps.googlePlayAria}>
						<img src={isEN ? googlePlayEN : googlePlayES} alt="Google Play" />
					</a>
				</div>
			</div>

			{/* <hr className="sf-footer-divider" /> */}

			{/* ===== BOTTOM SECTION ===== */}
			<div className="sf-footer-bottom">
				<div className="sf-footer-brand">
					{/* Placeholder logo – replace src later */}
					<img src={logo} alt="ReservaSinFila" className="sf-footer-logo" />
					<span>© {new Date().getFullYear()} ReservaSinFila. All rights reserved.</span>
				</div>

				<div className="sf-footer-socials">
					<a href="#" aria-label="Instagram">
						<FaInstagram />
					</a>
					<a href="#" aria-label="Facebook">
						<FaFacebookF />
					</a>
					<a href="#" aria-label="Twitter">
						<FaTwitter />
					</a>
				</div>
			</div>

			{/* ===== LANGUAGE SWITCH (Mobile Only) ===== */}
			<div className="sf-footer-switch">
				<button onClick={() => setLanguage(isEN ? "es" : "en")}>{translations[language].footer.languageSwitch}</button>
			</div>
		</footer>
	);
};

export default Footer;
